import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { retainActions } from "../../../../../../_actions";
import _ from "lodash";
import { CampaignSummaryMetricsBuilder } from "../objects/CampaignSummaryMetricsBuilder";
import { getCampaignRevenue } from "../../../RetainDashboard/Utilities/CampaignUtils";
import moment from "moment";

export default function ({ startDate, endDate, organizationId, campaignId }) {
  const dispatch = useDispatch();

  useEffect(() => {
    const payload = {
      startDate: moment(startDate).startOf('day').toISOString(),
      endDate: moment(endDate).startOf('day').toISOString(),
      organizationId,
      campaignId,
    };
    dispatch(retainActions.getSingleRetainCampaignMetrics(payload));
  }, [startDate, endDate, organizationId, campaignId]);

  const retainMetrics = useSelector((state) => state.retain);
  const loading = retainMetrics.loadingSingleRetainMetrics;
  const campaignsMetrics = retainMetrics.singleRetainMetrics;
  const builder = new CampaignSummaryMetricsBuilder();

  if (!loading) {
    builder.setTotalRevenue(getCampaignRevenue(_.get(campaignsMetrics, "totalRevenue")));
    builder.setAttributedRevenue(getCampaignRevenue(_.get(campaignsMetrics, "attributedRevenue")));
    builder.setRevenuePerRecipient(getCampaignRevenue(_.get(campaignsMetrics, "revenuePerRecipient")));
    builder.setLtvIncreaseRatio(_.get(campaignsMetrics, "ltvIncreaseRatio"));

    builder.setWinbackRevenue(getCampaignRevenue(_.get(campaignsMetrics, "winbackRevenue")));
    builder.setAdditionalRevenue(getCampaignRevenue(_.get(campaignsMetrics, "additionalRevenue")));

    builder.setAttributedWinbacks(_.get(campaignsMetrics, "attributedWinbacks"));
    builder.setAttributedRevenuePerRecipient(getCampaignRevenue(_.get(campaignsMetrics, "attributedRevenuePerRecipient")));

    builder.setWinbacks(_.get(campaignsMetrics, "winbacks"));
    builder.setTotalRecipients(_.get(campaignsMetrics, "totalRecipients"));
    builder.setWinbackRate(_.get(campaignsMetrics, "winbackRate"));
  }

  const data = builder.metrics || {};
  return { loading, data };
}
